export default from './Messages';



// WEBPACK FOOTER //
// ./src/sharedComponents/Chat/components/Messages/index.js